import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: "Home",
        missionStatement: "Mission statement",
        membership: "Membership",
        newsletter: "Newsletter",
        events: "Events",
        resources: "Resources",
        staff: "Staff",
        contact: "Contact"
      },
      hero: {
        title: "What is the Japanese Association of Jacksonville?",
        description: "We are a non-profit organization started in April 2018 to promote Japanese Culture and Heritage in Jacksonville, FL. We advocate programs and activities which include volunteerism, community involvement, and the celebration of Japanese culture. Anyone can join JAJ regardless of nationality and culture. We focus on developing friendship among its members and the local communities."
      },
      mission: {
        title: "Mission statement",
        statement: "The mission of the Japanese Association of Jacksonville is to build friendships, celebrate Japanese culture, and foster mutual understanding through educational, cultural, and community programs that connect people throughout Greater Jacksonville."
      },
      newsletter: {
        title: "Newsletters",
        subscribe: {
          title: "Subscribe to Our Newsletter",
          description: "Stay updated with our latest news, events, and community updates. Our newsletter is sent monthly and includes important announcements and upcoming events."
        },
        form: {
          email: "Email Address",
          submit: "Subscribe Now"
        },
        archive: {
          title: "Newsletter Archive"
        },
        info: {
          title: "Newsletter Information",
          frequency: "Our newsletter is published monthly and contains:",
          content: {
            events: "Upcoming events and activities",
            news: "Community news and updates",
            culture: "Cultural insights and stories",
            members: "Member spotlights",
            announcements: "Important announcements"
          }
        },
        latest: {
          title: "Latest Issue",
          viewButton: "View Latest",
          downloadButton: "Download"
        },
        actions: {
          view: "View Newsletter",
          download: "Download Newsletter",
          openBrowser: "Open in Browser",
          downloadPdf: "Download PDF"
        },
        viewer: {
          title: "PDF Viewer",
          loading: "Loading PDF...",
          mobileOptimized: "Mobile Optimized Viewing",
          notAvailable: "PDF Viewer Not Available",
          mobileMessage: "For the best viewing experience on mobile devices, please use one of the options below:",
          errorMessage: "The PDF cannot be displayed in this viewer. Please use one of the options below:",
          browserControls: "Use browser controls for navigation and additional features",
          mobileInstructions: "Tap buttons above for viewing options",
          openFullScreen: "Open in Full Screen"
        },
        fallback: {
          noNewsletters: "No newsletters available"
        },
        newsletters: {
          "2026-08": {
            title: "JAJ August 2026 Newsletter",
            description: "JAJ's August 2026 newsletter."
          },
          "2026-07": {
            title: "JAJ July 2026 Newsletter",
            description: "July community updates, cultural activities, and upcoming JAJ events."
          },
          "2026-05": {
            title: "JAJ May 2026 Newsletter",
            description: "May community updates, cultural activities, and upcoming JAJ events."
          },
          "2026-04": {
            title: "JAJ April 2026 Newsletter",
            description: "April community updates, cultural activities, and upcoming JAJ events."
          },
          "2026-03": {
            title: "JAJ March 2026 Newsletter",
            description: "March community updates, cultural activities, and upcoming JAJ events."
          },
          "2026-02": {
            title: "JAJ February 2026 Newsletter",
            description: "February community updates, cultural activities, and upcoming JAJ events."
          },
          "2025-11": {
            title: "JAJ November 2025 Newsletter",
            description: "November community updates, cultural activities, and upcoming JAJ events."
          },
          "2025-09": {
            title: "JAJ September 2025 Newsletter",
            description: "Fall celebrations, cultural workshops, and community updates. Back-to-school events and seasonal activities."
          },
          "2025-08": {
            title: "JAJ August 2025 Newsletter",
            description: "Summer activities, cultural festivals, and community gatherings. Member spotlights and upcoming fall events."
          },
          "2025-07": {
            title: "JAJ July 2025 Newsletter",
            description: "Summer festivals, Independence Day celebrations, and community activities. Cultural workshops and member spotlights."
          },
          "2025-06": {
            title: "JAJ June 2025 Newsletter",
            description: "Summer celebrations, cultural workshops, and community updates. New member introductions and community highlights."
          },
          "2025-05": {
            title: "JAJ May 2025 Newsletter",
            description: "Spring celebrations, Mother's Day events, and upcoming summer activities. Community updates and cultural workshops."
          },
          "2025-04": {
            title: "JAJ April 2025 Newsletter", 
            description: "Cherry blossom season celebrations, Easter events, and spring cultural activities. New member introductions and community highlights."
          },
          "2025-03": {
            title: "JAJ March 2025 Newsletter",
            description: "Spring awakening events, cultural workshops, and community gathering updates. Seasonal celebrations and member spotlights."
          },
          "2025-02": {
            title: "JAJ February 2025 Newsletter",
            description: "Valentine's Day celebrations, winter cultural activities, and community updates. Special events and member achievements."
          },
          "2025-01": {
            title: "JAJ January 2025 Newsletter",
            description: "New Year celebrations, 2025 goals and initiatives, community resolutions. Welcome messages and upcoming events preview."
          }
        }
      },
      events: {
        garageTitle: "JOIN US in JAJ's Annual Garage Sale!",
        garageDate: "February 21st(SAT)",
        garageTime: "9am - NOON",
        garageAddress: "308 Talwood Trace St. Johns, FL 32259",
        garageDonation: "If you want to donate for this garage sale, please drop off items with your name.",
        garageDropOff: "Drop off date: Feb. 5 (Sat) - Feb.11(Fri)",
        garageDropOffAddress: "Drop off address : 308 Talwood Trace St. Johns, FL 32259",
        garageJapanese: "毎年恒例のガレージセールを開催します！",
        worldOfNations: "WORLD OF NATIONS CELEBRATION",
        worldOfNationsDate: "February 26-27, 2022",
        worldOfNationsLocation: "@ Downtown Jacksonville",
        needVolunteers: "NEED VOLUNTEERS!",
        letsFun: "Let's have fun and represent JAPAN together!",
        helpWith: "WE NEED HELP WITH:",
        preparation: "Preparation",
        onSite: "On site",
        contact: "Would you like to help out?",
        contactEmail: "Please contact jaxjapanese@gmail.com"
      },
      tshirt: {
        title: "It's Finally Here!",
        subtitle: "JAJ's Original T-Shirt",
        sizes: "S, M, L & XL - $20",
        size2xl: "2XL - $25",
        slogan: "一期一会（ICHIGO ICHIE)",
        meaning: "Meeting Only Once in a Lifetime on the back side.",
        purchase: "To purchase, please email jaxjapanese@gmail.com"
      },
      facebook: {
        title: "Latest Updates",
        description: "Stay connected with our latest news, events, and community updates on Facebook.",
        followButton: "Follow us on Facebook"
      },
      sponsors: {
        title: "Sponsors",
        getNoticed: "Get Noticed By More Customers!",
        clickInfo: "Click here For Information!"
      },
      staff: {
        title: "Our Staff",
        positions: {
          president: "President",
          vicePresident: "Vice-President",
          adminAccounting: "Administration/Accounting",
          marketing: "Marketing"
        }
      },
      footer: {
        disclaimer: "Japanese Association of Jacksonville (JAJ) admits members of any race, nationality or ethnic origin to all rights. We do not discriminate on the basis of race, color, or national or ethnic origin in administration of event/programs. JAJ is a 501(c)(3) non- profit organization.",
        copyright: "Copyright © 2020 Japanese Association of Jacksonville, Florida",
        privacyPolicy: "Privacy Policy"
      }
    }
  },
  ja: {
    translation: {
      nav: {
        home: "ホーム",
        missionStatement: "基本理念",
        membership: "メンバーシップ",
        newsletter: "ニュースレター",
        events: "イベント",
        resources: "リソース",
        staff: "スタッフ",
        contact: "お問い合わせ"
      },
      hero: {
        title: "ジャクソンビル日本人会とは？",
        description: "私たちは2018年4月に設立された非営利団体で、フロリダ州ジャクソンビルで日本の文化と遺産を促進することを目的としています。ボランティア活動、地域参加、日本文化の祝賀を含むプログラムや活動を推進しています。国籍や文化に関係なく、誰でもJAJに参加できます。メンバーと地域コミュニティ間の友情の発展に焦点を当てています。"
      },
      mission: {
        title: "基本理念",
        statement: "ジャクソンビル日本人会は、友情を育み、日本文化を分かち合い、教育・文化・地域交流を通して相互理解を深め、ジャクソンビル地域の皆さまをつなぐことを目的としています。"
      },
      newsletter: {
        title: "ニュースレター",
        subscribe: {
          title: "ニュースレターを購読する",
          description: "最新のニュース、イベント、コミュニティの更新情報をお届けします。ニュースレターは毎月発行され、重要なお知らせや今後のイベント情報が含まれています。"
        },
        form: {
          email: "メールアドレス",
          submit: "今すぐ購読"
        },
        archive: {
          title: "ニュースレターアーカイブ"
        },
        info: {
          title: "ニュースレター情報",
          frequency: "ニュースレターは毎月発行され、以下の内容が含まれています：",
          content: {
            events: "今後のイベントと活動",
            news: "コミュニティニュースと更新情報",
            culture: "文化的洞察とストーリー",
            members: "メンバーのスポットライト",
            announcements: "重要なお知らせ"
          }
        },
        latest: {
          title: "最新号",
          viewButton: "最新号を見る",
          downloadButton: "ダウンロード"
        },
        actions: {
          view: "ニュースレターを見る",
          download: "ニュースレターをダウンロード",
          openBrowser: "ブラウザで開く",
          downloadPdf: "PDFをダウンロード"
        },
        viewer: {
          title: "PDFビューア",
          loading: "PDFを読み込み中...",
          mobileOptimized: "モバイル最適化表示",
          notAvailable: "PDFビューアが利用できません",
          mobileMessage: "モバイルデバイスで最適な表示体験を得るには、以下のオプションをご利用ください：",
          errorMessage: "このビューアでPDFを表示できません。以下のオプションをご利用ください：",
          browserControls: "ナビゲーションと追加機能にはブラウザのコントロールをご利用ください",
          mobileInstructions: "表示オプションについては上のボタンをタップしてください",
          openFullScreen: "フルスクリーンで開く"
        },
        fallback: {
          noNewsletters: "ニュースレターはありません"
        },
        newsletters: {
          "2026-08": {
            title: "JAJ 2026年8月号ニュースレター",
            description: "JAJの2026年8月号ニュースレター。"
          },
          "2026-07": {
            title: "JAJ 2026年7月号ニュースレター",
            description: "7月のコミュニティ更新情報、文化活動、今後のJAJイベント。"
          },
          "2026-05": {
            title: "JAJ 2026年5月号ニュースレター",
            description: "5月のコミュニティ更新情報、文化活動、今後のJAJイベント。"
          },
          "2026-04": {
            title: "JAJ 2026年4月号ニュースレター",
            description: "4月のコミュニティ更新情報、文化活動、今後のJAJイベント。"
          },
          "2026-03": {
            title: "JAJ 2026年3月号ニュースレター",
            description: "3月のコミュニティ更新情報、文化活動、今後のJAJイベント。"
          },
          "2026-02": {
            title: "JAJ 2026年2月号ニュースレター",
            description: "2月のコミュニティ更新情報、文化活動、今後のJAJイベント。"
          },
          "2025-11": {
            title: "JAJ 2025年11月号ニュースレター",
            description: "11月のコミュニティ更新情報、文化活動、今後のJAJイベント。"
          },
          "2025-09": {
            title: "JAJ 2025年9月号ニュースレター",
            description: "秋の祝賀行事、文化ワークショップ、コミュニティの更新情報。新学期イベントと季節の活動。"
          },
          "2025-08": {
            title: "JAJ 2025年8月号ニュースレター",
            description: "夏の活動、文化祭、コミュニティ集会。メンバーのスポットライトと今後の秋のイベント。"
          },
          "2025-07": {
            title: "JAJ 2025年7月号ニュースレター",
            description: "夏祭り、独立記念日の祝賀行事、コミュニティ活動。文化ワークショップとメンバーのスポットライト。"
          },
          "2025-05": {
            title: "JAJ 2025年5月号ニュースレター",
            description: "春の祝賀行事、母の日イベント、今後の夏の活動。コミュニティの更新情報と文化ワークショップ。"
          },
          "2025-04": {
            title: "JAJ 2025年4月号ニュースレター",
            description: "桜の季節の祝賀行事、イースターイベント、春の文化活動。新メンバーの紹介とコミュニティのハイライト。"
          },
          "2025-03": {
            title: "JAJ 2025年3月号ニュースレター",
            description: "春の目覚めイベント、文化ワークショップ、コミュニティ集会の更新情報。季節の祝賀行事とメンバーのスポットライト。"
          },
          "2025-02": {
            title: "JAJ 2025年2月号ニュースレター",
            description: "バレンタインデーの祝賀行事、冬の文化活動、コミュニティの更新情報。特別イベントとメンバーの功績。"
          },
          "2025-01": {
            title: "JAJ 2025年1月号ニュースレター",
            description: "新年の祝賀行事、2025年の目標と取り組み、コミュニティの決意。歓迎メッセージと今後のイベントプレビュー。"
          }
        }
      },
      events: {
        garageTitle: "JAJ年次ガレージセールにご参加ください！",
        garageDate: "2月21日（土）",
        garageTime: "午前9時 - 正午",
        garageAddress: "308 Talwood Trace St. Johns, FL 32259",
        garageDonation: "このガレージセールに寄付をご希望の場合は、お名前を書いて商品をお持ちください。",
        garageDropOff: "持ち込み日：2月5日（土）- 2月11日（金）",
        garageDropOffAddress: "持ち込み先住所：308 Talwood Trace St. Johns, FL 32259",
        garageJapanese: "毎年恒例のガレージセールを開催します！",
        worldOfNations: "ワールド・オブ・ネーションズ・セレブレーション",
        worldOfNationsDate: "2022年2月26-27日",
        worldOfNationsLocation: "@ ダウンタウン・ジャクソンビル",
        needVolunteers: "ボランティア募集！",
        letsFun: "一緒に楽しんで日本を代表しましょう！",
        helpWith: "お手伝いが必要な項目：",
        preparation: "準備",
        onSite: "当日",
        contact: "お手伝いいただけますか？",
        contactEmail: "jaxjapanese@gmail.com までご連絡ください"
      },
      tshirt: {
        title: "ついに登場！",
        subtitle: "JAJオリジナルTシャツ",
        sizes: "S、M、L、XL - $20",
        size2xl: "2XL - $25",
        slogan: "一期一会（ICHIGO ICHIE)",
        meaning: "裏面に「一生に一度の出会い」",
        purchase: "ご購入は jaxjapanese@gmail.com までメールでお問い合わせください"
      },
      facebook: {
        title: "最新情報",
        description: "Facebookで最新のニュース、イベント、コミュニティの更新情報をチェックしてください。",
        followButton: "Facebookをフォロー"
      },
      sponsors: {
        title: "スポンサー",
        getNoticed: "より多くのお客様に注目されませんか！",
        clickInfo: "詳細はこちらをクリック！"
      },
      staff: {
        title: "スタッフ紹介",
        positions: {
          president: "会長",
          vicePresident: "副会長",
          adminAccounting: "事務・会計",
          marketing: "マーケティング"
        }
      },
      footer: {
        disclaimer: "ジャクソンビル日本人会（JAJ）は、人種、国籍、民族的出身に関係なく、すべての権利にメンバーを受け入れます。イベント/プログラムの管理において、人種、肌の色、国籍または民族的出身に基づく差別は行いません。JAJは501(c)(3)非営利団体です。",
        copyright: "Copyright © 2020 Japanese Association of Jacksonville, Florida",
        privacyPolicy: "プライバシーポリシー"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 
